// extracted by mini-css-extract-plugin
export default {"container":"IDqI436nHKSGFRn6TOIR","tag":"VdedsmSHdJccryKqBTFi","events":"fhkS9cO2vXDbp9DvZAyQ","news":"_5paqlh32vu8MdyAYNov","dateTag":"UrnYuDAHtirMldeemrGu"};